import type { Ref } from "react";
import { useImperativeHandle, useRef } from "react";

import Button, { ButtonGroup } from "$src/core/components/atoms/Button/Button";
import Modal from "$src/core/components/atoms/Modal";
import type { ModalRef } from "$src/core/components/atoms/Modal/types";
import useTranslation from "$src/core/hooks/use-translation";
import type { SeasonDto } from "$src/core/models/dto";

type Props = {
  ref?: Ref<ModalRef>;
  seasons: SeasonDto[];
  selectedSeasonId: string | null;
  onSelect: (seasonId: string) => void;
};

const SeasonSelectorModal = ({
  ref: forwardedRef,
  seasons,
  selectedSeasonId,
  onSelect,
}: Props) => {
  const { t } = useTranslation();

  const ref = useRef<ModalRef | null>(null);

  useImperativeHandle(
    forwardedRef,
    () => ({
      present: () => ref.current?.present(),
      dismiss: () => ref.current?.dismiss(),
    }),
    [ref],
  );

  return (
    <Modal ref={ref} title={t("SEASON_SELECTOR_MODAL/TITLE")}>
      <ButtonGroup>
        {seasons.map((season) => (
          <Button
            key={season.id}
            name={`season_selector_${season.id}`}
            preset={
              season.id === selectedSeasonId ? "secondary" : "transparent"
            }
            label={season.title}
            onPress={() => onSelect(season.id)}
          />
        ))}
      </ButtonGroup>
    </Modal>
  );
};

export default SeasonSelectorModal;
